<template>
  <div class="container page">
    <div class="header">
      <van-nav-bar :title="$t('withdraw.log')" class="custom-nav-bar">
        <template #left>
          <van-icon name="arrow-left" @click="back()"/>
        </template>
      </van-nav-bar>
    </div>
    <div class="main">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-empty v-if="list.length === 0 && !loading" :description="$t('common.nodata')" class="custom-empty" />
      <van-list v-else
          v-model="loading"
          :finished="finished"
          :immediate-check="false"
          :finished-text="$t('common.nomore')"
          @load="onLoad">
            <div class="list-container">
            <van-cell-group class="custom-cell-group">
          <van-cell v-for="(item,i) in list" :key="i" class="custom-cell" is-link @click="openDetail(item)">
            <template #title>
              <div class="cell-header">
                <div class="cell-left">
                  <span class="title-text">{{$t('withdraw.title')}}</span>
                  <span class="amount">{{item.money}} Points</span>
                </div>
                <div class="cell-middle">
                  <span class="status" :class="getStatusClass(item.status)">
                    {{getStatusText(item.status)}}
                  </span>
                </div>
                <div class="cell-right">
                  <span class="notification-btn">{{$t('notification')}}</span>
                </div>
              </div>
              <div class="time-label">{{item.create_time}}</div>
            </template>
          </van-cell>
            </van-cell-group>
            </div>
      </van-list>
      </van-pull-refresh>
    </div>

    <van-popup v-model="detailVisible" round position="bottom" class="withdraw-detail-popup">
      <div v-if="selectedRecord" class="detail-panel">
        <div class="detail-handle"></div>
        <div class="detail-heading">
          <div>
            <span class="detail-kicker">WITHDRAWAL DETAIL</span>
            <h3>{{ $t('withdraw.log') }}</h3>
          </div>
          <span class="status detail-status" :class="getStatusClass(selectedRecord.status)">
            {{ getStatusText(selectedRecord.status) }}
          </span>
        </div>
        <div class="detail-amount">{{ selectedRecord.money }} <small>Points</small></div>
        <div class="detail-list">
          <div class="detail-row">
            <span>{{ detailLabels.order }}</span><strong>{{ detailValue(selectedRecord, ['order_no', 'withdraw_no', 'sn', 'id']) }}</strong>
          </div>
          <div class="detail-row">
            <span>{{ detailLabels.time }}</span><strong>{{ detailValue(selectedRecord, ['create_time', 'created_at', 'time']) }}</strong>
          </div>
          <div v-if="detailValue(selectedRecord, ['account', 'bank_account', 'address', 'wallet_address'], '')" class="detail-row">
            <span>{{ detailLabels.account }}</span><strong>{{ detailValue(selectedRecord, ['account', 'bank_account', 'address', 'wallet_address']) }}</strong>
          </div>
          <div class="detail-row detail-remark" :class="{ rejected: Number(selectedRecord.status) === 3 }">
            <span>{{ Number(selectedRecord.status) === 3 ? detailLabels.rejectReason : detailLabels.remark }}</span>
            <strong>{{ getRecordRemark(selectedRecord) }}</strong>
          </div>
        </div>
        <van-button block round class="detail-close" @click="detailVisible = false">{{ detailLabels.close }}</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      page: 1,
      refreshing: false,
      count: 0,
      limit: 10,
      loading: false,
      finished: false,
      list: [],
      detailVisible: false,
      selectedRecord: null,
      statusExt: ['', this.$t('withdraw.status1'), this.$t('withdraw.status2'), this.$t('withdraw.status3')],
    };
  },
  computed: {
    detailLabels() {
      return { order: 'Order No.', time: 'Request Time', account: 'Receiving Account', remark: 'Processing Note', rejectReason: 'Rejection Reason', close: 'Close' };
    }
  },
  methods: {
    back() {
      return window.history.back();
    },
    
    onRefresh() {
      // 重置分页数据
      this.page = 1;
      this.finished = false;
      this.loading = true;
      
      // 重新加载数据
      this.getUserWithdrawList(true);
    },
    
    onLoad() {
      // 加载更多数据
      if (this.finished) return;
      
      this.page++;
      this.getUserWithdrawList(false);
    },
    
    openDetail(item) {
      this.selectedRecord = item;
      this.detailVisible = true;
    },

    detailValue(item, fields, fallback = '-') {
      const field = fields.find(key => item[key] !== undefined && item[key] !== null && item[key] !== '');
      return field ? item[field] : fallback;
    },

    getRecordRemark(item) {
      return this.detailValue(item, [
        'reject_reason', 'refuse_reason', 'failure_reason', 'audit_remark',
        'remark', 'remarks', 'reason', 'desc', 'message', 'note'
      ], 'No note provided');
    },
    
    getUserWithdrawList(isRefresh = false) {
      this.$http({
        method: 'get',
        url: 'user_get_withdraw_list',
        data: {
          page: this.page,
          limit: this.limit
        }
      }).then(res => {
        if (res.code === 200) {
          if (isRefresh) {
            // 刷新时替换整个列表
            this.list = res.data || [];
          } else {
            // 加载更多时追加数据
            this.list = [...this.list, ...(res.data || [])];
          }
          
          // 更新分页状态
          this.count = res.count || 0;
          
          // 判断是否已加载完成
          if (!res.data || res.data.length < this.limit) {
            this.finished = true;
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
          this.$router.push('/Login');
        } else {
          this.$toast(res.msg || this.$t('common.loadFail'));
        }
      }).catch(error => {
        this.$toast(this.$t('common.networkError'));
        console.error('获取提现记录失败:', error);
      }).finally(() => {
        this.loading = false;
        this.refreshing = false;
      });
    },
    
    getStatusClass(status) {
      switch(Number(status)) {
        case 1: return 'status-pending';
        case 2: return 'status-success';
        case 3: return 'status-failed';
        default: return 'status-failed';
      }
    },
    
    getStatusText(status) {
      return this.statusExt[status] || this.$t('withdraw.status3');
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' });
    } else {
      this.loading = true;
      this.getUserWithdrawList();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.container {
  width: 100%;
  min-height: 100vh;
  background: white;
}

/* 顶部导航栏样式 - 填充渐变色 */
.custom-nav-bar {
  height: 3.5rem;
  line-height: 3.5rem;
  background: linear-gradient(135deg, #3498db 0%, #8e44ad 100%);
  position: relative;
  z-index: 10;
}

.custom-nav-bar::after {
  display: none;
}

.van-nav-bar__title {
  max-width: 60%;
  margin: 0 auto;
  color: white !important;
  font-weight: 600;
  font-size: 1.1rem;
}

.van-nav-bar__left {
  padding: 0 15px;
}

.van-nav-bar__left .van-icon {
  color: white !important;
  font-size: 1.2rem;
  font-weight: bold;
}

/* 主内容区域 */
.main {
  position: relative;
  overflow: auto;
  background-color: white;
  height: 100%;
  padding: 1rem;
}

.list-container {
  max-width: 100%;
}

/* 自定义单元格组 */
.custom-cell-group {
  background: transparent;
  border: none;
}

.custom-cell-group::after,
.custom-cell-group::before {
  display: none;
}

/* 每个栏目带边框 */
.custom-cell {
  margin-bottom: 0.8rem;
  border: 1.5px solid #e8e8e8;
  border-radius: 12px;
  padding: 1.2rem;
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: all 0.3s ease;
}

.custom-cell:active {
  background-color: #f8f9ff;
  border-color: #667eea;
  transform: translateY(1px);
}

.custom-cell::after {
  display: none;
}

/* 单元格标题区域 - 优化布局 */
.cell-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
  gap: 1rem;
}

.cell-left {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  flex: 1;
}

.title-text {
  font-weight: 600;
  color: #333;
  font-size: 1rem;
}

.amount {
  color: #667eea;
  font-weight: 600;
  font-size: 1.1rem;
}

/* 中间状态区域 */
.cell-middle {
  display: flex;
  justify-content: center;
  min-width: 70px;
}

/* 右侧通知按钮区域 */
.cell-right {
  display: flex;
  justify-content: flex-end;
  min-width: 60px;
}

.notification-btn {
  color: #667eea;
  font-size: 0.8rem;
  padding: 0.3rem 0.6rem;
  background: rgba(102, 126, 234, 0.1);
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  line-height: 1.2;
  height: auto;
}

.notification-btn:active {
  background: rgba(102, 126, 234, 0.2);
  transform: scale(0.95);
}

/* 状态样式 - 调整为和通知按钮相同大小 */
.status {
  font-size: 0.8rem;
  font-weight: 600;
  padding: 0.3rem 0.6rem;
  border-radius: 6px;
  white-space: nowrap;
  text-align: center;
  line-height: 1.2;
  height: auto;
}

.status-pending {
  color: #f59e0b;
  background: rgba(245, 158, 11, 0.1);
}

.status-success {
  color: #10b981;
  background: rgba(16, 185, 129, 0.1);
}

.status-failed {
  color: #ef4444;
  background: rgba(239, 68, 68, 0.1);
}

.time-label {
  color: #969799;
  font-size: 0.8rem;
  margin-top: 0.3rem;
}

/* 空状态样式 */
.custom-empty {
  padding: 3rem 1rem;
}

::v-deep .van-empty__description {
  color: #969799;
  font-size: 0.9rem;
}

/* 下拉刷新样式 */
::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #667eea;
  font-size: 0.9rem;
}

::v-deep .van-loading__text {
  color: #969799;
  font-size: 0.9rem;
}

/* 列表加载状态 */
::v-deep .van-list__finished-text {
  color: #969799;
  font-size: 0.9rem;
  padding: 1rem 0;
  text-align: center;
}

/* 动画效果 */
@keyframes fadeInUp {
  from { 
    opacity: 0; 
    transform: translateY(15px); 
  }
  to { 
    opacity: 1; 
    transform: translateY(0); 
  }
}

.custom-cell {
  animation: fadeInUp 0.4s ease forwards;
}

/* 响应式调整 */
@media (max-width: 320px) {
  .main {
    padding: 0.8rem;
  }
  
  .custom-cell {
    padding: 1rem;
    margin-bottom: 0.6rem;
  }
  
  .cell-header {
    gap: 0.5rem;
  }
  
  .cell-middle {
    min-width: 60px;
  }
  
  .cell-right {
    min-width: 50px;
  }
  
  .notification-btn {
    font-size: 0.75rem;
    padding: 0.2rem 0.5rem;
  }
  
  .status {
    font-size: 0.75rem;
    padding: 0.2rem 0.5rem;
  }
}

/* 平板端优化 */
@media (min-width: 768px) {
  .main {
    padding: 1.5rem;
  }
  
  .custom-cell {
    padding: 1.5rem;
  }
  
  .cell-middle {
    min-width: 80px;
  }
  
  .cell-right {
    min-width: 70px;
  }
  
  .notification-btn {
    font-size: 0.85rem;
    padding: 0.4rem 0.8rem;
  }
  
  .status {
    font-size: 0.85rem;
    padding: 0.4rem 0.8rem;
  }
}

/* 取款记录：黑金轻奢主题 */
.container {
  color: #f2e6cd;
  background:
    linear-gradient(rgba(3, 5, 8, .88), rgba(3, 5, 8, .97)),
    url('../../assets/img/luxury-dating-bg-v2.png') center top / cover fixed no-repeat;
}

.custom-nav-bar {
  height: 4rem;
  line-height: 4rem;
  background: rgba(4, 6, 9, .97);
  border-bottom: 1px solid rgba(220, 181, 101, .46);
  box-shadow: 0 10px 28px rgba(0, 0, 0, .42);
}

::v-deep .custom-nav-bar .van-nav-bar__title,
::v-deep .custom-nav-bar .van-icon {
  color: #edcd83 !important;
}

::v-deep .custom-nav-bar .van-nav-bar__title {
  font-size: 1.12rem;
  font-weight: 750;
  letter-spacing: .08em;
}

.main {
  min-height: calc(100vh - 4rem);
  padding: 1rem .8rem 2rem;
  background: transparent;
}

.custom-cell-group {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: .8rem;
}

.custom-cell {
  min-height: 9.2rem;
  margin: 0;
  padding: 1rem;
  border: 1px solid rgba(220, 181, 101, .38);
  border-radius: 20px;
  background:
    radial-gradient(circle at 92% 4%, rgba(221, 178, 91, .13), transparent 43%),
    linear-gradient(145deg, rgba(18, 20, 24, .97), rgba(5, 8, 12, .98));
  box-shadow: 0 14px 32px rgba(0, 0, 0, .38), inset 0 1px 0 rgba(255, 255, 255, .04);
}

.custom-cell:active {
  border-color: rgba(239, 207, 137, .72);
  background: linear-gradient(145deg, rgba(29, 24, 16, .98), rgba(6, 9, 13, .98));
}

.cell-header {
  position: relative;
  min-height: 6.7rem;
  margin: 0;
  align-items: flex-start;
}

.title-text {
  color: #a99b84;
  font-size: .84rem;
  font-weight: 650;
}

.amount {
  display: block;
  margin-top: .16rem;
  color: #edcd83;
  font-size: 1.05rem;
  font-weight: 780;
  line-height: 1.3;
  letter-spacing: .01em;
  white-space: nowrap;
}

.time-label {
  position: absolute;
  left: 1rem;
  bottom: .9rem;
  margin: 0;
  color: #948a7c;
  font-size: .76rem;
}

.cell-middle,
.cell-right {
  min-width: auto;
}

.status,
.notification-btn {
  padding: .38rem .62rem;
  border: 1px solid transparent;
  border-radius: 10px;
  font-size: .78rem;
  font-weight: 700;
}

.notification-btn {
  color: #e2c47f;
  border-color: rgba(220, 181, 101, .34);
  background: rgba(220, 181, 101, .09);
}

.status-pending {
  color: #f1c565;
  border-color: rgba(226, 178, 68, .25);
  background: rgba(226, 178, 68, .12);
}

.status-success {
  color: #66d7ad;
  border-color: rgba(71, 190, 145, .25);
  background: rgba(71, 190, 145, .12);
}

.status-failed {
  color: #ef8c82;
  border-color: rgba(224, 95, 84, .25);
  background: rgba(224, 95, 84, .12);
}

::v-deep .custom-cell .van-cell__right-icon {
  align-self: center;
  color: #dcbc72;
}

.withdraw-detail-popup {
  max-height: 82vh;
  padding: 0;
  color: #f2e6cd;
  background: #080b0f;
  border: 1px solid rgba(220, 181, 101, .55);
  box-shadow: 0 -20px 60px rgba(0, 0, 0, .7);
}

.detail-panel { padding: .65rem 1.25rem max(1.35rem, env(safe-area-inset-bottom)); }
.detail-handle { width: 2.8rem; height: 4px; margin: 0 auto 1.1rem; border-radius: 4px; background: rgba(237, 205, 131, .38); }
.detail-heading { display: flex; justify-content: space-between; align-items: center; gap: 1rem; }
.detail-kicker { color: #8f816b; font-size: .65rem; letter-spacing: .14em; }
.detail-heading h3 { margin: .2rem 0 0; color: #edcd83; font-size: 1.25rem; }
.detail-status { flex: 0 0 auto; }
.detail-amount { margin: 1.3rem 0; color: #f0ce7b; font-size: 2rem; font-weight: 800; }
.detail-amount small { font-size: .9rem; font-weight: 650; }
.detail-list { overflow: hidden; border: 1px solid rgba(220, 181, 101, .28); border-radius: 16px; background: rgba(255, 255, 255, .025); }
.detail-row { display: flex; justify-content: space-between; gap: 1rem; padding: .9rem 1rem; border-bottom: 1px solid rgba(220, 181, 101, .13); }
.detail-row:last-child { border-bottom: 0; }
.detail-row span { flex: 0 0 auto; color: #998d7b; font-size: .82rem; }
.detail-row strong { color: #e9ddc8; font-size: .84rem; font-weight: 600; text-align: right; overflow-wrap: anywhere; }
.detail-remark { align-items: flex-start; min-height: 3.5rem; }
.detail-remark.rejected { background: rgba(224, 95, 84, .08); }
.detail-remark.rejected span, .detail-remark.rejected strong { color: #ef9c93; }
.detail-close { height: 3rem; margin-top: 1.15rem; border: 0; color: #171006; font-weight: 750; background: linear-gradient(100deg, #bb873a, #edcf82, #c18b3e); }

::v-deep .van-list__finished-text {
  color: #8e8272;
}

@media (max-width: 390px) {
  .custom-cell-group { grid-template-columns: 1fr; }
  .custom-cell { min-height: 8rem; }
  .cell-header { min-height: 5.5rem; }
  .amount { font-size: 1.2rem; }
}

@media (max-width: 430px) {
  .container.page {
    width: 100%;
    min-width: 0;
    overflow-x: hidden;
    background-attachment: scroll;
  }

  .custom-nav-bar {
    height: auto;
    min-height: 58px;
    padding-top: env(safe-area-inset-top);
  }

  ::v-deep .custom-nav-bar .van-nav-bar__content {
    min-height: 58px;
  }

  ::v-deep .custom-nav-bar .van-nav-bar__title {
    max-width: calc(100% - 96px);
    font-size: 17px;
    line-height: 1.25;
    white-space: normal;
    overflow-wrap: anywhere;
  }

  .main {
    min-width: 0;
    min-height: calc(100svh - 58px);
    padding: 12px 10px max(22px, env(safe-area-inset-bottom));
    overflow-x: hidden;
  }

  .custom-cell-group {
    min-width: 0;
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .custom-cell {
    width: 100%;
    min-width: 0;
    min-height: 132px;
    padding: 14px 34px 14px 12px;
    border-radius: 17px;
  }

  .cell-header {
    min-width: 0;
    min-height: 92px;
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(78px, auto);
    grid-template-rows: auto auto;
    gap: 8px 10px;
    align-items: start;
  }

  .cell-left {
    min-width: 0;
    grid-row: 1 / span 2;
  }

  .cell-middle,
  .cell-right {
    min-width: 0;
    justify-content: flex-end;
  }

  .cell-middle {
    grid-column: 2;
    grid-row: 1;
  }

  .cell-right {
    grid-column: 2;
    grid-row: 2;
  }

  .title-text,
  .amount,
  .status,
  .notification-btn,
  .time-label {
    max-width: 100%;
    line-height: 1.35;
    overflow-wrap: anywhere;
  }

  .amount,
  .status,
  .notification-btn {
    white-space: normal;
  }

  .status,
  .notification-btn {
    padding: 6px 8px;
    font-size: 12px;
    text-align: center;
  }

  .time-label {
    right: 34px;
    bottom: 12px;
    font-size: 12px;
  }

  .withdraw-detail-popup {
    width: 100%;
    max-height: calc(100svh - env(safe-area-inset-top));
    overflow-y: auto;
  }

  .detail-panel {
    min-width: 0;
    padding: 10px 14px max(18px, env(safe-area-inset-bottom));
  }

  .detail-heading {
    min-width: 0;
    align-items: flex-start;
    gap: 10px;
  }

  .detail-heading > div {
    min-width: 0;
  }

  .detail-heading h3,
  .detail-kicker,
  .detail-status,
  .detail-amount {
    max-width: 100%;
    overflow-wrap: anywhere;
  }

  .detail-amount {
    font-size: clamp(27px, 9vw, 36px);
  }

  .detail-row {
    min-width: 0;
    gap: 10px;
    padding: 13px 12px;
  }

  .detail-row span,
  .detail-row strong {
    min-width: 0;
    line-height: 1.4;
    overflow-wrap: anywhere;
  }
}

@media (max-width: 350px) {
  .cell-header {
    grid-template-columns: minmax(0, 1fr) minmax(70px, auto);
  }

  .detail-row {
    flex-direction: column;
    gap: 5px;
  }

  .detail-row strong {
    text-align: left;
  }
}
</style>
